import request from '@/utils/request'

// 分页查询销售业绩信息
export function getPageList(params) {
  return request({
    url: '/hrApi/performanceRecord',
    method: 'get',
    params: params
  })
}

// 获取销售业绩列表
export function getList(params) {
  return request({
    url: '/hrApi/performanceRecord/list',
    method: 'get',
    params: params
  })
}

// 获取销售业绩列表 - 按年
export function getYearList(params) {
  return request({
    url: '/hrApi/performanceRecord/list/year',
    method: 'get',
    params: params
  })
}

// 获取销售业绩列表 - 按月
export function getMonthList(params) {
  return request({
    url: '/hrApi/performanceRecord/list/month',
    method: 'get',
    params: params
  })
}

// 新增或编辑销售业绩
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/performanceRecord',
    method: 'post',
    data: data
  })
}

// 删除销售业绩
export function deleteData(id) {
  return request({
    url: '/hrApi/performanceRecord/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/performanceRecord.js